<div class="side-by-side-tabs position-relative">
    <div class="panel-title">
        Export the data
    </div>
    <button type="button" class="close" aria-label="Close" title="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div [formGroup]="exportDataForm">
        <div class="export-bg-pop">
        <div class="mt-top-2 modal-form modal-form-export-data">
            <div>
            <div class="d-flex">
                <mat-form-field>
                    <mat-label>Site</mat-label>
                    <input matInput formControlName="site">
                    <ng-container *ngIf="userSubmit && exportDataFormValues['site'].errors">
                        <mat-error *ngIf="exportDataFormValues['site'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Site is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="d-flex">
                <mat-form-field>
                    <mat-label>Patient ID</mat-label>
                    <input matInput formControlName="patientId">
                    <ng-container *ngIf="userSubmit && exportDataFormValues['patientId'].errors">
                        <mat-error *ngIf="exportDataFormValues['patientId'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Patient ID is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="d-flex">
                <mat-form-field>
                    <mat-label>Patient Name</mat-label>
                    <input matInput formControlName="patientName">
                    <ng-container *ngIf="userSubmit && exportDataFormValues['patientName'].errors">
                        <mat-error *ngIf="exportDataFormValues['patientName'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Patient Name is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
        </div>
        <div>
            <div>Export Data By</div>
            <div class="d-flex">
                <!-- <mat-checkbox class="example-margin" formControlName="exportDateToday"
                    (change)="todayData($event,'today')">
                    Today</mat-checkbox>
                <mat-checkbox class="example-margin" (change)="todayData($event,'Last7days')">
                    Last 7 days</mat-checkbox>
                <mat-checkbox class="example-margin" (change)="todayData($event,'Custom')">
                    Customise</mat-checkbox> -->
                <mat-radio-group>
                    <mat-radio-button value="today" [checked]="true" (change)="todayData('today')">Today
                    </mat-radio-button>
                    <mat-radio-button value="Last7days" (change)="todayData('Last7days')">Last 7 Days
                    </mat-radio-button>
                    <mat-radio-button value="Custom" (change)="todayData('Custom')">Custom</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="d-flex">
                <mat-form-field class="field">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="startDate" (click)="picker.open()"
                        [max]="minDate" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <ng-container>
                        <mat-error *ngIf="userSubmit && exportDataFormValues['startDate']?.errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>StartDate is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Time</mat-label>
                    <input type="time" matInput name="start" formControlName="startTime">
                </mat-form-field>
            </div>
            <div class="d-flex">
                <mat-form-field class="field">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="endDate" [max]="minDate"
                        (click)="picker1.open()" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                    <ng-container>
                        <mat-error *ngIf="userSubmit && exportDataFormValues['endDate']?.errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>EndDate is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Time</mat-label>
                    <input type="time" matInput name="end" formControlName="endTime">
                </mat-form-field>
            </div>
        </div>
       
    </div>
    <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="onSubmit()">Export <img  src="../../../../assets/images/file-download-icon.svg" class="ml-2"></button>
    </div>  </div>
</div>
    <div class="red-color" style="text-align: center;" *ngIf="errorMsg">{{errorMsg}}</div>
</div>